import { setRangeMin } from './helpers';

export const setRoomsForSaleMin = setRangeMin('rooms_for_sale');
